import { observer } from "mobx-react-lite";
import { useNationalLeagueStore } from "../../../store/StoreContext";
import { Button } from "../../../components/button/Button";
import { Colors } from "../../../utils/colors";
import LoadingSpinner from "../../../components/loadingSpinner/LoadingSpinner";

type props = {
  isDisabled: boolean;
  onClose: () => void;
};

export const CreateLeagueBottomSheetBottomView = observer(
  ({ isDisabled, onClose }: props) => {
    const nationalLeagueStore = useNationalLeagueStore();

    return nationalLeagueStore.isLeagueCreationInProgress ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 20,
          marginBottom: 30,
        }}>
        <LoadingSpinner loading={true} />
      </div>
    ) : (
      <Button
        disabled={isDisabled}
        text="Create League"
        onPress={async () => {
          await nationalLeagueStore.createNationalLeague();
          onClose();
        }}
        btnStyle={{
          paddingLeft: 40,
          paddingRight: 40,
          height: 50,
          backgroundColor: Colors.darkBrown,
          width: "100%",
          marginTop: 20,
          marginBottom: 30,
        }}
        textStyle={{
          color: "white",
          fontWeight: 600,
          fontSize: 14,
        }}
      />
    );
  }
);
